import { create } from "zustand";
import {
  CampaignStatus,
  type ICampaign,
} from "../types/models/campaign.models.types";

interface ICampaignStore {
  data: ICampaign;
  setData: (data: ICampaign) => void;
  fetching: boolean;
  setFetching: (fetching: boolean) => void;
}

const useCampaignStore = create<ICampaignStore>((set) => ({
  data: {
    campaignStatus: {
      status: CampaignStatus.brandDraft,
    },
  } as ICampaign,
  setData: (data: ICampaign) => set(() => ({ data })),
  fetching: false,
  setFetching: (fetching: boolean) => set(() => ({ fetching })),
}));

export default useCampaignStore;
